import { useRouter } from 'vue-router';
import { useGlobalStore } from '@/stores/globalStore';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';
import useApiHelpers from '@/composables/api/helpers';
import { PaymentStatus } from '@/composables/payments/paymentStatus';

const { getRequest } = useApiHelpers();

export default function useRedirectPayments() {
  /**
   * Get Merchant Return URLs
   *
   * @returns { Object } - { successUrl, cancelledUrl, failedUrl }
   */
  const getPartnerReturnUrl = async () => {
    const globalStore = useGlobalStore();
    const orderStore = useOrderFormStore();
    if (!orderStore.getActiveStore?.form?.walletAddress?.fromApi) {
      const partnerReturnUrls = globalStore.getMerchantSettings?.returnPaymentUrls;
      return {
        successUrl: partnerReturnUrls?.return_url_on_success,
        cancelledUrl: partnerReturnUrls?.return_url_on_cancelled,
        failedUrl: partnerReturnUrls?.return_url_on_failure,
      };
    }

    const orderIdResponse = await getRequest('/orderId');
    const statusResponse = await getRequest(`/status/${orderIdResponse.data.orderId}`);
    const { partnerReturnUrl } = statusResponse.data.data;
    return {
      successUrl: partnerReturnUrl.data.return_url_on_success,
      cancelledUrl: partnerReturnUrl.data.return_url_on_cancelled,
      failedUrl: partnerReturnUrl.data.return_url_on_failure,
    };
  };

  /**
   * Handle cancelled and failure payment redirection
   *
   * Current payment that has a cancellation options - Worldpay
   *
   * @param {{PaymentStatus, String}} paymentStatus, route
   */
  const handleFailureRedirect = async (callbackData) => {
    const globalStore = useGlobalStore();
    const router = useRouter();
    const { cancelledUrl, failedUrl } = await getPartnerReturnUrl();
    const { paymentStatus, route } = callbackData;
    if (
      callbackData
      && Object.prototype.hasOwnProperty.call(callbackData, 'paymentStatus')
      && (cancelledUrl || failedUrl)
    ) {
      switch (paymentStatus) {
        case PaymentStatus.cancelled: {
          window.top.location = cancelledUrl;
          break;
        }
        case PaymentStatus.failed: {
          window.top.location = failedUrl;
          break;
        }
        case PaymentStatus.isRedirect: {
          router.push(route);
          break;
        }
        default: {
          router.push('/');
          break;
        }
      }
    } else {
      const merchantReturnUrl = globalStore.getMerchantSettings?.returnUrl;
      if (merchantReturnUrl) {
        window.top.location = merchantReturnUrl;
      } else {
        router.push('/');
      }
    }
  };

  return {
    handleFailureRedirect,
  };
}
